import { Component, Input, OnInit } from '@angular/core';
import moment from 'moment';

@Component({
  selector: 'msd-history-separator',
  templateUrl: './history-separator.component.html',
  styleUrls: ['./history-separator.component.scss'],
})
export class HistorySeparatorComponent implements OnInit {
  @Input() date: Date;

  constructor() {}

  ngOnInit(): void {}

  get formattedDate() {
    return moment(this.date).format('[Le] DD MMMM yyyy');
  }
}
